<template>
  <div role="radiogroup" :aria-label="label">
    <div v-if="label" :class="[
      'form-label',
      { 'text-danger': !!v$.$errors.length }
    ]">
      {{ label }}<span v-if="required" class="text-danger">*</span>
    </div>

    <div :class="btnsClass">
      <StepSelection class="pb-0">
        <RadioButtons
          :label="label"
          :options="options"
          :readonly="readonly"
          :required="required"
          v-model="model"
          v-model:setFocus="hasFocus"
        />
      </StepSelection>
    </div>

    <!-- A slot for other content to be rendered alongside the radio buttons (on sufficiently large
      screens). -->
    <!-- NOTE: Since this can contain fields with nested validation, splitting up radio buttons into
      two components helps keep validation state separate. -->
    <slot name="other-content"></slot>
  </div>
</template>

<script>
/* eslint-disable import/extensions */
import { useVuelidate } from '@vuelidate/core';
import focusable from '@ssi/vue-common/src/mixins/focusable';
import RadioButtons from './Buttons.vue';
import StepSelection from '../../requestWizard/StepSelection.vue';

export default {
  name: 'RadioButtonsWrapper',

  setup() {
    return {
      v$: useVuelidate()
    };
  },

  mixins: [focusable],

  components: { StepSelection, RadioButtons },

  props: {
    /* Additional class(es) for the radio buttons container */
    btnsClass: {
      type: String
    },

    label: {
      type: String
    },

    options: {
      type: Array,
      required: true
    },

    required: {
      type: Boolean,
      default: () => false
    },

    readonly: {
      type: Boolean,
      default: () => false
    },

    modelValue: [Boolean, String]
  },

  emits: ['update:modelValue'],

  computed: {
    model: {
      get: ({ modelValue }) => modelValue,
      set(newValue) {
        this.$emit('update:modelValue', newValue);
      }
    },
  },
};
</script>
